import React, { useEffect, useState, useContext } from "react";

import { ContextNotificacoes } from "../../../services/notificacoes";

import { ReactComponent as History } from "../../../assets/history.svg";

import { Spinner } from "../../StyledComponent";

import { useHistory } from "react-router-dom";

function formatDate(date) {
  return date?.split("T")[0].split("-").reverse().join("/");
}

const BoletosParcelas = ({
  pendentes,
  vencidas,
  tema,
  setNotificationsModal,
  tipo,
  mostrarTitulo,
}) => {
  const history = useHistory();

  const [load, setLoad] = useState(true);

  const {
    marcarNotificacaoFinanceiroComoLida,
    atualizaNotificacoes,
  } = useContext(ContextNotificacoes);

  useEffect(() => {
    if (pendentes !== null && vencidas !== null) setLoad(false);
  }, [pendentes, vencidas]);

  function redirectToFinanceiro(idVenda) {
    history.push({
      pathname: "/financeiro",
      state: {
        idVenda,
      },
    });
  }

  async function marcarComoLido(
    IdReceber,
    DataVencimento,
    IdVenda,
    BancoBoleto,
    SeuNumero,
    vencida,
    visualizado
  ) {
    let dados = {
      ReceberIdReceber: IdReceber,
      DataVencimento: DataVencimento,
      IdVenda: IdVenda,
      BancoBoleto: BancoBoleto,
      SeuNumero: SeuNumero,
    };

    let path = "";

    if (!visualizado) {
      if (tipo === "parcela" && vencida)
        // marcar parcela vencida
        path = "MarcarNotificacaoParcelaVencida";
      // marcar parcela pendente
      else if (tipo === "parcela" && !vencida)
        path = "MarcarNotificacaoParcelaPendente";
      // marcar boleto vencido
      else if (tipo !== "parcela" && vencida)
        path = "MarcarNotificacaoBoletoVencido";
      // marcar boleto pendente
      else if (tipo !== "parcela" && !vencida)
        path = "MarcarNotificacaoBoletoPendente";
      try {
        await marcarNotificacaoFinanceiroComoLida(path, dados);
      } catch (error) {
        return [];
      } finally {
        // redirectToFinanceiro(IdVenda);
        setNotificationsModal(false);
        await atualizaNotificacoes();
      }
    }
  }

  const msgParcelaVencida = (diasVencidos) => {
    if (diasVencidos < 25)
      return `O seu boleto vencido já expirou. Para gerar um novo boleto,
    clique aqui.`;
    else if (diasVencidos >= 25 && diasVencidos < 45)
      return `Devido ao débito vencido seu CPF será negativado nos órgaos restritivos de crédito nos próximos dias.
      Clique aqui e regularize seu débito.`;
    else if (diasVencidos >= 45 && diasVencidos < 75)
      return `O seu boleto vencido já expirou. Para gerar um novo boleto, clique aqui.`;
    else if (diasVencidos >= 75)
      return `Última chance de regularizar seus débitos vencidos de forma amigável. Para gerar um novo boleto, clique aqui.`;
  };

  if (load) return <Spinner />;

  if (pendentes?.length === 0 && vencidas?.length === 0) return null;
  return (
    <div
      className="notifications__item"
      style={
        mostrarTitulo
          ? { paddingBottom: "0" }
          : { padding: "0", marginTop: "0" }
      }
    >
      {/* para vencidos */}
      {vencidas?.length > 0 &&
        vencidas?.map((notif, index) => {
          return (
            <div key={index} className="centralized-space-between">
              <div className="centralized">
                <span
                  style={{ width: "24px", height: "24px", display: "block" }}
                >
                  <History
                    style={
                      notif?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  />
                </span>

                {notif.DiasVencidos < 20 && (
                  <>
                    {!notif?.BoletoAgrupado && (
                      <p
                        className="notifications__item__description"
                        style={
                          notif?.Visualizado
                            ? { color: "#AAAAAA" }
                            : { color: "#454545" }
                        }
                      >
                        Ainda não identificamos o pagamento{" "}
                        {tipo === "parcela"
                          ? "da parcela"
                          : "do boleto que contempla a parcela"}{" "}
                        nº{" "}
                        <b>
                          {notif?.NumeroParcela} - {notif?.DescricaoParcela}
                        </b>
                        . Caso já tenha efetuado o pagamento, desconsidere a
                        mensagem.
                      </p>
                    )}

                    {notif?.BoletoAgrupado && (
                      <p
                        className="notifications__item__description"
                        style={
                          notif?.Visualizado
                            ? { color: "#AAAAAA" }
                            : { color: "#454545" }
                        }
                      >
                        Ainda não identificamos o pagamento do boleto que
                        contempla as parcelas nº{" "}
                        <b>
                          {notif?.NumeroParcela + " - "}
                          {notif?.NumeroParcelaBoletoAgrupado.map(
                            (b, index) => {
                              return <span key={index}>{b} - </span>;
                            }
                          )}
                        </b>{" "}
                        . Caso já tenha efetuado o pagamento, desconsidere a
                        mensagem.
                      </p>
                    )}
                  </>
                )}

                {notif.DiasVencidos >= 20 && (
                  <p
                    className="notifications__item__description"
                    style={
                      notif?.Visualizado
                        ? { color: "#AAAAAA" }
                        : { color: "#454545" }
                    }
                  >
                    {msgParcelaVencida(notif.DiasVencidos)}
                  </p>
                )}
              </div>
              <a
                style={{ color: tema.primaryColor, cursor: "pointer" }}
                onClick={() => {
                  marcarComoLido(
                    notif?.IdReceber,
                    notif?.DtVencBoleto ?? notif?.DataVencimento,
                    notif?.IdVenda,
                    notif?.BancoBoleto,
                    notif?.SeuNumero,
                    "vencida",
                    notif.Visualizado
                  );
                  redirectToFinanceiro(
                    notif?.IdVendaPrincipal ?? notif?.IdVenda
                  );
                  setNotificationsModal(false);
                }}
                id={`txtBoletoVencido${index}`}
              >
                VISUALIZAR
              </a>
            </div>
          );
        })}

      {/* para a vencer */}
      {pendentes?.length > 0 &&
        pendentes?.map((notif, index) => {
          return (
            <div key={index} className="centralized-space-between">
              <div className="centralized">
                <span
                  style={{ width: "24px", height: "24px", display: "block" }}
                >
                  <History
                    style={
                      notif?.Visualizado
                        ? { fill: "#D1D1D1" }
                        : { fill: tema.primaryColor }
                    }
                  />
                </span>
                {!notif?.BoletoAgrupado && (
                  <p
                    className="notifications__item__description"
                    style={
                      notif?.Visualizado
                        ? { color: "#AAAAAA" }
                        : { color: "#454545" }
                    }
                  >
                    Você tem{" "}
                    {tipo == "parcela"
                      ? "a parcela"
                      : "o boleto que contempla a parcela"}{" "}
                    parcela nº{" "}
                    <b>
                      {notif?.NumeroParcela} - {notif?.DescricaoParcela}
                    </b>{" "}
                    vencendo no dia{" "}
                    <b>
                      {tipo === "parcela"
                        ? formatDate(notif?.DataVencimento)
                        : formatDate(notif?.DtVencBoleto)}
                    </b>
                    . Caso já tenha efetuado o pagamento, desconsidere a
                    mensagem.
                  </p>
                )}

                {notif?.BoletoAgrupado && (
                  <p
                    className="notifications__item__description"
                    style={
                      notif?.Visualizado
                        ? { color: "#AAAAAA" }
                        : { color: "#454545" }
                    }
                  >
                    Você tem um boleto que contempla as parcelas nº{" "}
                    <b>
                      {notif?.NumeroParcela + " - "}
                      {notif?.NumeroParcelaBoletoAgrupado.map((b, index) => {
                        return <span key={index}>{b} - </span>;
                      })}
                    </b>{" "}
                    vencendo no dia{" "}
                    <b>
                      <span>{formatDate(notif?.DtVencBoleto)}</span>
                    </b>
                    . Caso já tenha efetuado o pagamento, desconsidere a
                    mensagem.
                  </p>
                )}
              </div>
              <a
                style={{ color: tema.primaryColor, cursor: "pointer" }}
                onClick={() => {
                  marcarComoLido(
                    notif?.IdReceber,
                    notif?.DtVencBoleto ?? notif?.DataVencimento,
                    notif?.IdVenda,
                    notif?.BancoBoleto,
                    notif?.SeuNumero,
                    ""
                  );

                  redirectToFinanceiro(
                    notif?.IdVendaPrincipal ?? notif?.IdVenda
                  );
                  setNotificationsModal(false);
                }}
                id={`txtBoletoAVencer${index}`}
              >
                VISUALIZAR
              </a>
            </div>
          );
        })}
    </div>
  );
};

export default BoletosParcelas;
